import ButtonItemType from './button-item-type';

export default class ButtonItem {
  constructor(data) {
    this.action = null;
    this.label = null;
    this.type = [];
    // Initialize data
    if (data) {
      Object.assign(this, {
        action: data.Action,
        label: data.Label,
        type: new ButtonItemType(data.Type)
      });
    }
  }
}



// WEBPACK FOOTER //
// src/entities/case/case-button-items/button-item.js